"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paddedNumber = exports.humanReadableSize = exports.humanReadableFileTypes = void 0;
var humanReadableSize = exports.humanReadableSize = function humanReadableSize(bytes) {
  if (bytes < 1024) {
    return "".concat(bytes, " B");
  }
  if (bytes < 1024 * 1024) {
    return "".concat((bytes / 1024).toFixed(1), " KB");
  }
  if (bytes < 1024 * 1024 * 1024) {
    return "".concat((bytes / 1024 / 1024).toFixed(1), " MB");
  }
  return "".concat((bytes / 1024 / 1024 / 1024).toFixed(1), " GB");
};
var humanReadableFileTypes = exports.humanReadableFileTypes = function humanReadableFileTypes(fileFormats) {
  if (!Array.isArray(fileFormats)) {
    return '';
  }
  return fileFormats.reduce(function (result, fileFormat) {
    var fileFormatName = typeof fileFormat === 'string' ? fileFormat : fileFormat.subtype;
    return result ? result.concat(", ".concat(fileFormatName)) : fileFormatName;
  }, null).toUpperCase();
};
var paddedNumber = exports.paddedNumber = function paddedNumber(number) {
  return number.toString().padStart(2, '0');
};